import { lazyLoad } from 'utils/loadable';

export const SnackbarManager = lazyLoad(
  () => import('./index'),
  module => module.default,
);
